import { forwardRef, useCallback } from 'react';
import { IonInput } from '@ionic/react';
import classNames from 'classnames';

import { BaseFieldAutoComplete, BaseFieldProps } from '../Fields.types';
import { FieldWrapper } from '../FieldWrapper';

import { FieldTextOnInputHandler } from './FieldText.types';

import styles from '../Fields.module.scss';

export interface FieldTextProps extends BaseFieldProps<string> {
  maxLength?: number;
  autoComplete?: BaseFieldAutoComplete;
}

export const FieldText = forwardRef<HTMLIonInputElement, FieldTextProps>(
  (
    {
      id,
      label,
      error,
      value,
      onKeyDown,
      onKeyUp,
      onCompositionUpdate,
      placeholder,
      disabled,
      onChange,
      onBlur,
      maxLength,
      readOnly,
      onFocus,
      autoComplete,
    },
    ref
  ) => {
    const invalid = !!error;

    const handleOnIonInput: FieldTextOnInputHandler = useCallback(
      (event) => {
        onChange({
          event,
          value: event.detail.value,
        });
      },
      [onChange]
    );

    return (
      <FieldWrapper label={label} invalid={invalid}>
        <IonInput
          type="text"
          fill="outline"
          labelPlacement="stacked"
          id={id}
          ref={ref}
          value={value}
          onIonBlur={onBlur}
          onIonInput={handleOnIonInput}
          disabled={disabled}
          readonly={readOnly}
          maxlength={maxLength}
          placeholder={placeholder}
          onIonFocus={onFocus}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          autocomplete={autoComplete}
          onCompositionUpdate={onCompositionUpdate}
          errorText={error}
          className={classNames(styles.input, {
            'ion-invalid': invalid,
            'ion-touched': invalid,
          })}
        />
      </FieldWrapper>
    );
  }
);
